module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\"><path fill-rule=\"evenodd\" d=\"M9.996 13.14L15.993 7H4z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/svgo-loader?{"plugins":[{"removeTitle":true}]}!./resources/assets/img/arrowdown.svg
// module id = vQ9a
// module chunks = 1